<template>
  <div class="c_carousel c_box--break_out" :class="carouselContainsCaption() ? 'c_carousel--with_captions' : ''">
    <agile class="c_carousel__slider" ref="carousel" v-if="images" :unagile="slideTotal < 2" :options="{ dots: false }">
      <div class="c_carousel__slider__slide" v-for="(slide, index) in images" :key="index">
        <div class="c_carousel__slider__slide__grid" v-if="slide.image?.[0]">
          <MediaImage
            class="c_carousel__slider__slide__image"
            background
            loading="eager"
            :alt="slide.image[0].title || null"
            :sources="formatSources(slide.image[0])"
          />
          <div class="c_carousel__slider__slide__caption" v-if="slide.caption" v-html="slide.caption"></div>
        </div>
      </div>
      <template slot="prevButton"
        ><IconSVG
          class="c_carousel__slider__arrows c_carousel__slider__arrows__prev"
          handle="arrow_left"
          :replacements="{ 'Arrow Left': $t('Previous Slide') }"
      /></template>
      <template slot="nextButton"
        ><IconSVG
          class="c_carousel__slider__arrows c_carousel__slider__arrows__next"
          handle="arrow_right"
          :replacements="{ 'Arrow Right': $t('Next Slide') }"
      /></template>
    </agile>
  </div>
</template>

<script>
// import { log } from 'JS/global.js';
import { VueAgile } from 'vue-agile';
import IconSVG from 'Components/icon_svg/IconSVG.vue';
import MediaImage from 'Components/image/MediaImage.vue';
export default {
  components: {
    agile: VueAgile,
    IconSVG,
    MediaImage,
  },
  data() {
    return {};
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
    imageOptimizedFields: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formatSources(image) {
      const returnSources = [];
      for (let i = 0; i < this.imageOptimizedFields.length; i++) {
        returnSources.push({ srcset: image[this.imageOptimizedFields[i]].srcsetWebp, type: 'webp' });
        returnSources.push({ srcset: image[this.imageOptimizedFields[i]].srcset });
      }
      return returnSources;
    },
    carouselContainsCaption() {
      return this.images ? this.images.some((el) => el.caption) : false;
    },
  },
  computed: {
    slideTotal() {
      return this.images ? this.images.length : 0;
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss">
.c_carousel {
  $self: &;
  overflow: hidden;
  --carousel-image-height: #{px_to_rem(700)};
  --carousel-slide-spacing: #{px_to_rem(35)};
  --carousel-arrow-height: #{px_to_rem(20)};
  --carousel-arrow-width: #{px_to_rem(10)};

  @at-root #{$self}__slider {
    height: px_to_rem(500);
    margin-left: auto;
    margin-right: auto;
    max-width: calc(90% - #{px_to_rem(30)});
    @include mq($mq_sm_to_md) {
      max-width: calc(85% - (var(--carousel-slide-spacing) * 2));
      height: var(--carousel-image-height);
    }
    @include mq($mq_carousel_1) {
      max-width: calc(#{$max_width} + (var(--carousel-slide-spacing) * 2));
    }

    .agile__list,
    .agile__track {
      height: 100%;
      overflow: visible;
    }

    .agile__slides {
      max-width: none !important;
    }
    @at-root #{&}__slide {
      position: relative;
      box-sizing: border-box;
      height: 100%;
      padding: 0 px_to_rem(15);
      @include mq($mq_sm_to_md) {
        padding: 0 var(--carousel-slide-spacing);
      }
      @at-root #{&}__grid {
        position: relative;
        height: 100%;
        display: grid;
        grid-gap: px_to_rem(25);
        grid-template-rows: px_to_rem(400);

        @at-root .app--isEdge15orDown & {
          display: flex;
          flex-flow: column nowrap;
        }
        @at-root #{$self}--with_captions #{&} {
          grid-template-rows: px_to_rem(400) px_to_rem(120);
        }
        @include mq($mq_sm_to_md) {
          grid-template-rows: 6fr;
          @at-root #{$self}--with_captions #{&} {
            grid-template-rows: 5fr 1fr;
          }
        }
      }
      @at-root #{&}__image {
        grid-row: 1;
        //margin:0 auto;
      }
      @at-root #{&}__caption {
        display: none;
        grid-row: 2;
        font-size: px_to_rem(14);
        @at-root #{$self}--with_captions #{&} {
          display: block;
        }
        @include mq($mq_sm_to_md) {
          font-size: inherit;
        }
      }
    }
    .agile__nav-button {
      @include button_reset;
      position: absolute;
      top: 50%;
      width: 30px;
      transform: translateY(-50%);
      @at-root #{$self}--main--arrows--overlay & {
        width: auto;
      }
      @at-root #{$self}--thumbnails--arrows--overlay & {
        width: auto;
      }
      /* @at-root #{$self}--main & {
        --slider-arrow-distance-offset: 14px;
      } */

      @at-root #{&}--prev {
        @include mq(0, '', 'rem') {
          left: calc(-30px - var(--slider-arrow-distance-offset-xsm, 0px));
        }
        @include mq(450, '', 'rem') {
          left: calc(-30px - var(--slider-arrow-distance-offset-sm, 0px));
        }
        @include mq($mq_sm_to_md, '', 'rem') {
          left: calc(-30px - var(--slider-arrow-distance-offset-md, 0px));
        }
        @include mq($mq_md_to_lg, '', 'rem') {
          left: calc(-30px - var(--slider-arrow-distance-offset-lg, 0px));
        }
        text-align: right;
        .c_icon_svg {
          margin-right: 0;
          margin-left: auto;
        }
      }
      @at-root #{&}--next {
        @include mq(0, '', 'rem') {
          right: calc(-30px - var(--slider-arrow-distance-offset-xsm, 0px));
        }
        @include mq(450, '', 'rem') {
          right: calc(-30px - var(--slider-arrow-distance-offset-sm, 0px));
        }
        @include mq($mq_sm_to_md, '', 'rem') {
          right: calc(-30px - var(--slider-arrow-distance-offset-md, 0px));
        }
        @include mq($mq_md_to_lg, '', 'rem') {
          right: calc(-30px - var(--slider-arrow-distance-offset-lg, 0px));
        }
        text-align: left;
        .c_icon_svg {
          margin-right: auto;
          margin-left: 0;
        }
      }

      --slider-arrow-distance-offset: #{px_to_rem(-20)};
      height: var(--carousel-arrow-height);
      width: var(--carousel-arrow-width);
      &:hover,
      &:focus {
        color: $color_red;
      }

      @at-root .c_box--black #{&} {
        color: $color_white;
        &:hover,
        &:focus {
          color: $color_red;
        }
      }
      svg {
        --slider-arrow-svg-height: var(--carousel-arrow-height);
        --slider-arrow-svg-width: var(--carousel-arrow-width);
      }
    }
  }
}
</style>
